import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export interface TestimonialCardProps {
  name: string;
  review: string;
  rating: number;
  avatarUrl: string;
}
function StarRating({
  rating
}: {
  rating: number;
}) {
  return <div className="flex gap-0.5" data-id="element-57">
      {[1, 2, 3, 4, 5].map(star => {
      const fill = Math.min(1, Math.max(0, rating - (star - 1)));
      return <div key={star} className="relative w-4 h-4" data-id="element-58">
            {/* Empty star background */}
            <svg className="w-4 h-4 text-rosegold/20" viewBox="0 0 20 20" fill="currentColor" data-id="element-59">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-60" />
            </svg>
            {/* Filled star overlay with clip */}
            <div className="absolute inset-0 overflow-hidden" style={{
          width: `${fill * 100}%`
        }} data-id="element-61">
              <svg className="w-4 h-4 text-rosegold" viewBox="0 0 20 20" fill="currentColor" data-id="element-62">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-63" />
              </svg>
            </div>
          </div>;
    })}
    </div>;
}
export function TestimonialCard({
  name,
  review,
  rating,
  avatarUrl
}: TestimonialCardProps) {
  return <div className="bg-midnight-light border border-white/5 rounded-2xl p-6 md:p-8 flex flex-col h-full shadow-xl" data-id="element-64">
      <div className="flex items-center justify-between mb-6" data-id="element-65">
        <StarRating rating={rating} data-id="element-66" />
        <div className="flex items-center text-teal-400 text-xs font-inter font-medium" data-id="element-67">
          <CheckCircle2Icon className="w-3.5 h-3.5 mr-1" data-id="element-68" />
          <span className="hidden sm:inline" data-id="element-69">Verified Purchase</span>
          <span className="sm:hidden" data-id="element-70">Verified</span>
        </div>
      </div>

      <p className="font-inter text-warmwhite/90 text-sm md:text-base leading-relaxed mb-8 flex-grow italic" data-id="element-71">
        "{review}"
      </p>

      <div className="flex items-center mt-auto" data-id="element-72">
        <img src={avatarUrl} alt={name} className="w-12 h-12 rounded-full object-cover border border-white/10 mr-4" data-id="element-73" />
        <div data-id="element-74">
          <h4 className="font-inter font-semibold text-warmwhite text-sm" data-id="element-75">
            {name}
          </h4>
        </div>
      </div>
    </div>;
}